module.exports = __webpack_public_path__ + "img/baner2_large.486cd761.webp";